<template>
    <table>
        <tbody>
            <tr>
                <td>Code de partage du projet</td>
                <td>{{ projectCode }}</td>
                <td>
                    <button @click.stop="copyValue()" class="btn btn-icon"><i class="bi bi-copy" title="Copier"></i></button>
                </td>
                <td>
                    <button @click.stop="regenerateCode()" class="btn btn-icon"><i class="bi bi-recycle" title="Régénérer"></i></button>
                </td>
            </tr>
        </tbody>
    </table>
    <!-- <div>
        Ce code est unique à chaque projet et permet de partager le projet avec d'autres utilisateurs.
        Vous pouvez regénérer ce code à tout moment
    </div> -->


    <!-- Roles manager -->
    <div class="container">
        <h1>Maîtres d'ouvrage du projet</h1>
        <br>
        <!-- <div class="card flex">
            <input 
            @input="searchUser"
            v-model="searchString" 
            type="text" 
            class="p-inputtext-sm p-d-block p-mb-2"/>
            <br>
            <br>
            <AutoComplete v-model="searchString" optionLabel="email" :suggestions="usersWithoutAccess" @complete="searchUser"/>
        </div> -->
        <DataTable :value="usersWithAccess || []" :paginator="false" dataKey="user_id">
            <Column field="validator" header="Maître d'oeuvre" :sortable="true" >
                <template #body="slotProps">
                    <input 
                        v-if="slotProps.data.user_id !== userCreator"
                        @change="toggleSelected(slotProps.data, 'PC', $event.target.checked)" 
                        :checked="checkAccessForUser(slotProps.data, 'PC')"
                        type="checkbox" />
                </template>
            </Column>
            <Column field="name" header="Nom" :sortable="true" />
            <Column field="surname" header="Prénom" :sortable="true" />
            <Column field="username" header="Nom utilisateur" :sortable="true">
                <template #body="slotProps">
                    <span>{{ slotProps.data.username }}</span>
                    <i v-if="slotProps.data.admin === 1" class="bi bi-shield-fill" title="admin"></i>
                </template>
            </Column>
            <Column field="email" header="Email" :sortable="true" />
            <!-- <Column field="editor" header="Accès au projet" :sortable="true">
                <template #body="slotProps">
                    <input 
                        @change="toggleSelected(slotProps.data, 'PE', $event.target.checked)" 
                        :checked="checkAccessForUser(slotProps.data, 'PE')"
                        type="checkbox" />
                </template>
            </Column> -->

            <!-- PC = PROJECT CREATOR, DO NOT MODIFY IT (only for the MO ???)-->
        </DataTable>
    </div>
</template>

<script> 
import { mapState, mapGetters } from 'vuex'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
    name: "ProjectShareCode",
    components:{
        DataTable,
        Column  
    },
    data() {
        return {
            projectCode: "",
            //roles manager
            searchString: "",
            isReady:false,
            filteredUsers: [],
        }
    },
    computed: {
        ...mapState("project", ["projectData", "selectedProject", "userList", "userListRightsProject", "roles"]),
        ...mapGetters("project", ["usersWithAccess", "usersWithoutAccess"]),
        ...mapState("auth", ["user"]),
        userCreator() {
        if (!this.selectedProject) return false;
        const selectedProject = this.projectData.find( p => {
            return p.project_id === this.selectedProject
        })
        return selectedProject.created_by
    }
    },
    async mounted() {
        const codeFromDB = await this.getProjectCode();
        this.projectCode = codeFromDB;

        if (!this.projectCode || this.projectCode.length <= 0) {
            this.createCode();
        } else {
            //console.log("Project code found and assigned:", this.projectCode);
        }
        //Roles Manager
        this.isReady = true;
        this.isReady = true;
        
        if(this.selectedProject === 0) {
            if(this.$route.params.id) {
                this.$store.commit("project/selectProjectMutation", this.$route.params.id)
            }
        } else {
            //console.log("project already loaded")
        }
        if(this.roles){
         this.loadUsers().then(() => {
            //console.log("User list loaded", this.userList)
            //console.log("Selected users with access", this.usersWithAccess)
            //console.log("Selected users without access", this.usersWithoutAccess)
            
        }).catch((error) => {
            console.error("Error loading user list:", error)
        })
    }
    },
    watch: {
        selectedProject(newVal) {
            if (newVal) {
                //console.log("Selected project changed to:", newVal)
                this.loadUsers()
            }
        }
    },
    methods: {
        async getProjectCode() { 
            const projectId = parseInt(this.$route.params.id);
            await this.$store.dispatch("project/fetchProjectList");
            const project = this.projectData.find(p => p.project_id === projectId);
            
            //console.log("Found Project in DB:", project ? project.sharecode : 'No project found');

            if (project) {
                return project.sharecode || "";
            }
            return "";
        },
        async createCode() {
            //console.log("Creating new project code because none was found in DB.");
            this.projectCode = this.randomShareCodeGenerator();
            await this.$store.dispatch('project/projectUpdate', { project_id: this.$route.params.id, sharecode: this.projectCode });
        },
        async regenerateCode() {
            const code = this.randomShareCodeGenerator();
            //console.log("Generated new code:", code);
            this.projectCode = code;
            await this.$store.dispatch('project/projectUpdate', { project_id: this.$route.params.id, sharecode: this.projectCode });
        },
        copyValue() {
            navigator.clipboard.writeText(this.projectCode).then(() => {
                //console.log("Code copied to clipboard:", this.projectCode);
            }).catch(err => {
                console.error("Failed to copy code:", err);
            });
        },
        randomShareCodeGenerator() {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
            let shareCode = ''
            for (let i = 0; i < 8; i++) {
                shareCode += characters.charAt(Math.floor(Math.random() * characters.length))
            }
            return shareCode
        },

        // Roles manager
        checkAccessForUser(user, type) {
            if(type === "PC") {
                return user.PC
            }
            console.error("We got no user yet, so we need to check what is inside user", user)
            return false
        },
        async loadUsers() {
            /* //console.log("loadUsers called") */
            await this.$store.dispatch("project/fetchUserList", this.selectedProject)
                .then(() => {
                    //console.log("User list loaded", this.userList)
                    //console.log("User rights", this.userListRightsProject)
                })
                .catch((error) => {
                    console.error("Error loading user list:", error)
                })
        },
        toggleSelected(user, type, checked) {
            this.$store.dispatch("project/toggleUserAccess", { user : user, project_id: this.selectedProject, type: type, checked: checked })
            .then(() => {
                //console.log("User rights", this.userListRightsProject)
            })
            .catch((error) => {
                console.error("Error loading user list:", error)
            })
        },
        searchUser() {
            setTimeout(() => {
                // //console.log("searchUser called with event: ", event)
                //console.log("searchString: ", this.searchString)
                if(!this.searchString.trim().length || this.searchString.trim().length <= 2) {
                    // this.filteredUsers.value = [...this.usersWithoutAccess]
                    this.filteredUsers = []
                    /* //console.log("returning :", this.filteredUsers) */
                } else {
                    //console.log("Filtering users with query: ", this.searchString)
                    this.filteredUsers = this.usersWithoutAccess.filter((user) => {
                        return user.name.toLowerCase().includes(this.searchString.toLowerCase()) || user.surname.toLowerCase().includes(this.searchString.toLowerCase()) || user.email.toLowerCase().includes(this.searchString.toLowerCase())
                    })
                    //console.log("Filtered users: ", this.filteredUsers)
                }
            }, 250)
        },
    }
}
</script>

<style scoped>
.container {
    padding: 2rem;
    background-color: var(--bg-color);
  }
  
  
  :deep(.p-datatable){
    border-radius: 8px;
  }
  
  :deep(.p-datatable-header-cell){
      padding: 5px 0px 12px 0;
      margin:5vh;
  }
  
  :deep(.p-datatable-tbody){
      padding-top: 15px;
  }
  
  :deep(.p-datatable-tbody > tr > td){
      padding: 12px 6px 10px 1px;
      border-bottom: 1px solid transparent !important;
      border-top: 1px solid transparent !important;
  }
  
  :deep(.p-datatable-tbody > tr){
      border: none !important;
  }
  
  :deep(.p-datatable-tbody > tr:hover) {
      background-color: var(--hover-bg);
      transition: all 0.3s ease;
  }
  
  :deep(.p-datatable-tbody > tr:hover > td) {
      border-bottom: 1px solid black !important;
      border-top: 1px solid black !important;
  }
  
  :deep(.p-datatable-thead > tr > th) {
      font-weight: 600;
  }
  
  input[type="checkbox"] {
    transform: scale(1.2);
    cursor: pointer;
  }
  
  .p-inputtext-sm {
    width: 100%;
    max-width: 800px;
    padding: 0.75rem;
    border-radius: 6px;
    border: 2px solid #dee2e6;
  }
  
  .card.flex {
      box-shadow: none;
  }
  
  .p-inputtext-sm:focus {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.25);
    border-radius: var(--border-radius);
  }
  
  :deep(.p-datatable-paginator-bottom){
      border: none;
      padding: 3vh 0 0 0;
  }
  
  :deep(.p-paginator-content){
      gap: 2vw;
      text-align:center;
  }
  .bi-shield-fill{
    color:var(--left3-color);
    margin-left: 0.3vw;
  }
</style>